export  const Methodes = [
    {
        id: '01f09',
        order: 1,
        name: 'Understand client brief and website purpose'
    },
    {
        id: '01a09',
        order: 2,
        name: 'Analyse and create the database'
    },
    {
        id: '01r09',
        order: 3,
        name: 'look for inspiration and create the mock-up'
    },
    {
        id: '01t09',
        order: 4,
        name: 'Start developing the website'
    },
    {
        id: '01j09',
        order: 5,
        name: 'Test'
    },
]